'use client';

import { CardWithGradient } from '@components/card';
import { CTAButtons } from '@components/ctaButtons';
import { Typography } from '@components/typography';

import { StartSectionItem } from '../types';

interface StartSectionProps {
  items: StartSectionItem[];
}

export const StartSection = ({ items }: StartSectionProps) => {
  return (
    <div className="flex gap-8 px-4 max-sm:flex-col max-sm:gap-4">
      {items.map((item) => {
        return (
          <CardWithGradient
            key={item.id}
            variant="blur"
            pcPlacement={item.bgPosition}
            mobilePlacement={item.bgPosition}
          >
            <div className="flex h-[260px] flex-col justify-between gap-2 p-6 max-sm:h-[224px] max-sm:p-5">
              <div className="flex flex-col gap-2">
                <Typography variant="heading-s">{item.title}</Typography>
                <Typography variant="text-base" className="secondary">
                  {item.description}
                </Typography>
              </div>
              <div className="flex items-center justify-between">
                {item.icon}
                <CTAButtons secondaryButton={item.button} />
              </div>
            </div>
          </CardWithGradient>
        );
      })}
    </div>
  );
};
